import { useRoutes } from "react-router-dom";

import AppRoutes from "./AppRoutes";
import AuthenticationRoutes from "./AuthenticationRoutes";

export default function Routes() {
  return useRoutes([AuthenticationRoutes, AppRoutes]);
}
